export const borderIOHeaders = {
  'X-RapidAPI-Host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
  'X-RapidAPI-Key': 'ce1058c13bmsha3ebe3154c59baap128400jsn6cb6c31a49ee',
};

export const GEO_TYPE = {
  GEO_FENCING: 'GEO_FENCING',
  GEO_TARGETING: 'GEO_TARGETING',
  GEO_REPORTING: 'GEO_REPORTING',
};

export const INITIAL_VIEW_STATE = {
  width: '100%',
  height: '400px',
  latitude: 38,
  longitude: -97,
  zoom: 3,
  bearing: 0,
  pitch: 0,
};

export const INITIAL_GEO_JSON = {
  type: 'FeatureCollection',
  features: [],
};

export const BASE_MAP_SCALES = {
  STATE: 'State',
  DMA: 'DMA',
  COUNTY: 'County',
  ZIP: 'ZIP',
  CONGRESSIONAL_DISTRICTS: 'Congressional Districts',
  COUNTRY: 'Country',
};

export const MAP_SCALES = {
  ...BASE_MAP_SCALES,
  CITY: 'City',
};

export const MAPBOX_GEOCODING_API = 'https://api.mapbox.com/geocoding/v5/mapbox.places/';

export const US_GEOGRAPHIC_BOUNDS = {
  ALASKA: {
    LON_MIN: -170,
    LON_MAX: -130,
    LAT_MIN: 50,
    LAT_MAX: 72,
  },
  MAINLAND: {
    LON_MIN: -130,
    LON_MAX: -65,
    LAT_MIN: 25,
    LAT_MAX: 50,
  },
};
